<template>
  <div class="products-jdd-page-content flex flex-col items-center w-full text-left">
    <!-- banner 包含移动端 -->
    <PageBanner :content="content.bannerInfo" />

    <PageBusinessCol :content="content.businessIntroduction" />

    <!-- 产品功能介绍 中间左右布局的内容 -->
    <PageFunction :content="content.featuresIntroduction" />

    <!-- 产品优势 -->
    <PageAdvantage :content="content.advantage" :extraTitleStyle="{ color: '#272E3B' }" />

    <SiteMap />
  </div>

</template>

<script setup lang="ts">
import { ref, shallowReactive, onMounted, onUnmounted } from 'vue'
import { useSeoMeta } from 'nuxt/app'
const title = '即得电'
const description = '重塑应急充电场景 释放即时能源价值'
useSeoMeta({
  title,
  description,
})

const content = shallowReactive({
  bannerInfo: {
    banner: '/images/pages/products/jdd/banner.png',
    mobileBanner: '/images/mobile/products/jdd.png'
  },
  businessIntroduction: {
    title: '产品业务介绍',
    description: [
      '物联网智能充电网络，以“硬件革新 +智慧运营”双轮驱动，破解传统设备故障多、归还难、运维贵等痛点',
      '提供全场景即时能源解决方案，轻量化设计适配于餐饮、商超、交通枢纽等多场景，部署灵活高效',
    ],
    descImage: '/images/pages/products/jdd/c-1.png',
  },
  featuresIntroduction: {
    title: '产品功能介绍',
    desc: '',
    extraCardBackColor: 'bg-#F6F8FD',
    extraTitleClass: 'bg-#F6F8FD w-100%!',
    groups: [
      {
        title: '设备管理',
        desc: '',
        descList: [
          '对充电宝设备进行全生命周期数字化管理，实现设备状态的实时监控、远程控制与高效入库。',
          '通过设备看板集中展示运行数据，帮助企业精准掌握设备分布与健康状况，提升资产利用率和运维响应效率。',
        ],
        icon: '/images/pages/products/jdd/f-i- (1).png',
        mainImage: '/images/pages/products/jdd/f- (1).png',
        direction: 'image-to-copywriting'
      },
      {
        title: '订单管理',
        desc: '',
        descList: [
          '支持订单从生成到归还的全流程自动化处理，覆盖多种业务场景。',
          '系统实时同步订单状态，提供灵活的业务类型配置，确保订单流转高效、透明，助力企业实现订单履约过程的精细化管理。'
        ],
        icon: '/images/pages/products/jdd/f-i- (2).png',
        mainImage: '/images/pages/products/jdd/f- (2).png',
        direction: 'copywriting-to-image'
      },
      {
        title: '用户账户',
        desc: '',
        descList: [
          '为用户提供便捷的注册与登录流程，并集成权限控制与资产查看功能。',
          '通过账户安全中心保障用户信息与资金安全，实现用户数据统一管理，提升使用体验与平台信任度。  '
        ],
        icon: '/images/pages/products/jdd/f-i- (3).png',
        mainImage: '/images/pages/products/jdd/f- (3).png',
        direction: 'image-to-copywriting'
      },
      {
        title: '商家管理',
        desc: '',
        descList: [
          '为合作商家提供一站式入驻流程与数字化管理支持。系统清晰展示商家旗下设备的分布与运营状况，助力商家拓展点位、优化布局，实现合作共赢与资源高效整合。',],
        icon: '/images/pages/products/jdd/f-i- (4).png',
        mainImage: '/images/pages/products/jdd/f- (4).png',
        direction: 'copywriting-to-image'
      },
      {
        title: '运营调度',
        desc: '',
        descList: [
          '整合智能巡检、维修管理、工单调度与路径规划等功能，实现运维任务的自动化派发与过程跟踪。',
          '有效提升线下运营效率，降低故障处理时长，保障服务网络稳定运行。',
        ],
        icon: '/images/pages/products/jdd/f-i- (5).png',
        mainImage: '/images/pages/products/jdd/f- (5).png',
        direction: 'image-to-copywriting'
      },
      {
        title: '计费结算',
        desc: '',
        descList: [
          '提供灵活可配置的计费规则与分账机制，自动生成清晰对账单并支持发票申领与管理。',
          '系统实现结算流程自动化，提升财务处理效率，降低人工核算成本。',
        ],
        icon: '/images/pages/products/jdd/f-i- (6).png',
        mainImage: '/images/pages/products/jdd/f- (6).png',
        direction: 'copywriting-to-image'
      }, {
        title: '营销活动',
        desc: '',
        descList: [
          '通过优惠券、会员体系与多样化营销活动，增强用户粘性与复购率。',
          '支持活动效果跟踪与数据分析，帮助企业制定精准营销策略，提升市场竞争力。',
        ],
        icon: '/images/pages/products/jdd/f-i- (7).png',
        mainImage: '/images/pages/products/jdd/f- (7).png',
        direction: 'image-to-copywriting'
      }, {
        title: '数据分析',
        desc: '',
        descList: [
          '汇聚设备、订单、用户等多维数据，提供可视化报表与预测分析。',
          '帮助企业洞察运营趋势、识别优化点，实现数据驱动的科学决策与业务持续增长。'
        ],
        icon: '/images/pages/products/jdd/f-i- (8).png',
        mainImage: '/images/pages/products/jdd/f- (8).png',
        direction: 'copywriting-to-image'
      },
    ]
  },
  advantage: {
    title: '产品优势',
    desc: '专业团队技术能力更强，运维有保障',
    background: '/images/pages/products/jdd/b-b.png',
    list: [
      {

        briefBack: '/images/pages/products/jdd/b- (2).png',
      },
      {
        briefBack: '/images/pages/products/jdd/b- (3).png',
      },
      {
        briefBack: '/images/pages/products/jdd/b- (1).png',
      },
    ]
  }
})

</script>

<style scoped lang="scss">
@import "@base/@core/scss/template/libs/vuetify/variables";

.products-jdd-page-content {
  max-width: $page-max-width;
  background-color: #fff;

  @media (max-width: 1023.9px) {
    padding-top: $table-header-height;
  }

  .jdd-business-number-cooperative-stores {
    position: absolute;
    top: 120px;
    right: 0;
    display: flex;
    width: 16.5rem;
    height: 5.32rem;
    padding-top: 20px;
    padding-left: 30px;
    border-radius: 0;
    background-image: url("/images/pages/products/jdd/Frame 2147229605@2x.png");
    background-size: cover;
  }

  .features-group-ul {
    .features-group-li {
      position: relative;
      padding-left: 2rem;

      &::before {
        position: absolute;
        z-index: 0;
        top: 5px;
        left: 0;
        width: 19px;
        height: 19px;
        background-image: url("/images/pages/products/jdd/圆点.png");
        background-size: cover;
        content: "";
      }
    }
  }
}

.jdd-product-advantage {
  background-image: url("/images/pages/products/jdd/product_bottom_next.png");
  background-size: cover;
}

.accordion-container {
  display: flex;
  height: 300px;
  gap: 1rem;

  .accordion-item {
    overflow: hidden;
    flex: 1;
    cursor: pointer;
    transition: all 1s ease;

    &:hover,
    &.active {
      flex: 3;
    }

    :deep(img) {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 1s ease;
    }

    &:not(.active):hover :deep(img) {
      // transform: scale(1.05);
    }
  }
}
</style>
